import React from 'react';
import PageContainer from '../../components/PageComponents/layouts/PageContainer';
import SafetyNav from '../../components/SafetyNav';
import List from './List';

const breadcrumbs = [{ label: 'Safety Documents', isActive: true }];

const SafetyDocuments = () => (
  <PageContainer heading="SAFETY DOCUMENTS" breadcrumbs={breadcrumbs}>
    <SafetyNav />
    <List />
  </PageContainer>
);

export default SafetyDocuments;
